// src/controllers/monedaController.js

import { getMonedas, createMoneda, updateMoneda, deleteMoneda } from '../models/monedaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchMonedas(page, perPage) {
  try {
    const response = await getMonedas(page, perPage);
    return {
      moneda: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching monedas:", error);
    Swal.fire('Error', 'No se pudieron cargar las monedas', 'error');
    return null;
  }
}

export async function saveMoneda(moneda, currentMonedaId) {
  try {
    if (currentMonedaId) {
      await updateMoneda(currentMonedaId, moneda);
      toasts.add({
        title: 'Éxito',
        description: 'Moneda guardada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createMoneda(moneda);
      toasts.add({
        title: 'Éxito',
        description: 'Moneda creada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving moneda:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la moneda',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeMoneda(id) {
  try {
    await deleteMoneda(id);
    toasts.add({
      title: 'Éxito',
      description: 'Moneda eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting moneda:", error);
    Swal.fire('Error', 'No se pudo eliminar la moneda', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'moneda'
export function subscribeToMonedas(searchQuery, handleSearch) {
  pb.collection('moneda').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromMonedas() {
  pb.collection('moneda').unsubscribe('*');
}

export async function searchMonedas(query, page = 1, perPage = 10) {
  const response = await pb.collection('moneda').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    moneda: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}
